/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Grid,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { connect } from 'react-redux';
import {
  PictureAsPdf as PictureAsPdfIcon,
  Slideshow as SlideshowIcon,
} from '@material-ui/icons';
import { FaFilePowerpoint } from 'react-icons/fa';
import RessourceCard from './ResourceCard';
import uiActions from '../../../../redux/actions/uiActions';
import userActions from '../../../../redux/actions/userActions';
import Player from '../../../shared/Player';
import Dictionnary from '../../../Dictionnary';
import useIsSmallScreen from '../../../../hooks/useIsSmallScreen';

const useStyles = makeStyles({
  paddingweb: {
    padding: '1em 0 10em 0',
  },
  paddingmobile: {
    padding: '1em',
    paddingLeft: '10px',
    paddingRight: '10px',
  },
});

const DisplayResources = ({
  data,
  currentGroup,
  changePageTitle,
}) => {
  const [url, setUrl] = useState('');
  const classes = useStyles();
  const isSmallScreen = useIsSmallScreen();

  // Retrieve file type
  const getExtension = (str) => {
    const extension = str.split('.').pop();
    return extension;
  };

  useEffect(() => {
    changePageTitle('E-Learning | Resources');
  }, []);

  const handleUrl = (_url) => {
    if (_url === url) {
      setUrl('');
    } else {
      setUrl(_url);
    }
  };

  return (
    <Container className={!isSmallScreen ? classes.paddingweb : classes.paddingmobile}>
      <Dictionnary />
      { data[currentGroup].elearning.elearningResources.length <= 0
        ? (
          <Typography
            component="p"
            variant="body1"
            style={{
              width: '100%', textAlign: 'center', marginTop: 15, fontSize: '1.4em',
            }}
          >
            No additional documents have been added for this course.
          </Typography>
        )
        : null}
      {url
        ? <Player url={url} />
        : null }
      <Grid container direction="row" spacing={4}>
        {
          data[currentGroup].elearning.elearningResources.map((resource) => {
            const ext = getExtension(resource.filename);
            if (ext === 'pdf') {
              return (
                <RessourceCard
                  setUrl={handleUrl}
                  key={resource.filename}
                  title={resource.title}
                  filename={resource.filename}
                  icon={<PictureAsPdfIcon color="secondary" style={{ fontSize: '1em', marginTop: '25%' }} />}
                  thumbnail={resource.thumbnail}
                  type="pdf"
                />
              );
            }
            if (ext === 'pptx' || ext === 'ppt') {
              return (
                <RessourceCard
                  setUrl={handleUrl}
                  key={resource.filename}
                  title={resource.title}
                  filename={resource.filename}
                  icon={<FaFilePowerpoint size={45} color="#D04423" />}
                  thumbnail={resource.thumbnail}
                  type="ppt"
                />
              );
            }
            return (
              <RessourceCard
                setUrl={handleUrl}
                key={resource.filename}
                title={resource.title}
                filename={resource.filename}
                icon={<SlideshowIcon color="secondary" style={{ fontSize: '0.95em', marginTop: '15%' }} />}
                type="video"
              />
            );
          })
        }
      </Grid>
    </Container>
  );
};

DisplayResources.propTypes = {
  data: PropTypes.array.isRequired,
  currentGroup: PropTypes.number.isRequired,
  changePageTitle: PropTypes.func.isRequired,
};

const actionCreators = {
  changePageTitle: uiActions.changePageTitle,
  logout: userActions.logout,
};

const mapState = (state) => {
  const { data } = state.group;
  const { currentGroup } = state.ui;
  const { userData } = state.user;
  const userId = userData._id;
  return {
    data, currentGroup, groupId: data[currentGroup]._id, userId,
  };
};

export default connect(mapState, actionCreators)(DisplayResources);
